import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { AttendeeService } from 'src/app/service/attendee.service';
import { UtilityService } from 'src/app/service/utility.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { ScheduleMeetingPopupComponent } from '../schedule-meeting-popup/schedule-meeting-popup.component';
import { environment, environment_const } from 'src/environments/environment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PermissionService } from 'src/app/service/permission.service';
import { NgxSpinnerService } from 'ngx-spinner';
// const moment = _rollupMoment || _moment;
const moment = require('moment');

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-followup-meeting-popup',
  templateUrl: './followup-meeting-popup.component.html',
  styleUrls: ['./followup-meeting-popup.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class FollowupMeetingPopupComponent implements OnInit {
  participantControl = new UntypedFormControl();
  //toppingList: string[] = ['T Lavanya', 'Shankar', 'M Shiva Kumar', 'M Prabhu'];
  attendeeList :any;
  agendaControl = new UntypedFormControl([]);
  //agendaList: string[] = ['Untitled Meeting', 'First Meeting', 'Jikan Meeting'];
  agendaList: any;
  participants= new UntypedFormControl('');
  selectedParticipant :any;
  selectedAgenda :any;
  agenda= new UntypedFormControl('');
  loggedInUserId:any;
  disableUser=false;
  //selectedUserList:any;
  // @Input() meetingInfo : any;


  
  //setDate = new Date();
  constructor(private util:UtilityService,private permissionService:PermissionService,private attendeeService:AttendeeService,private sideNav : SideNavServiceService,private meetingService:MeetingService,private globals:Globals, private matDialogRef: MatDialogRef<ScheduleMeetingPopupComponent>,@Inject(MAT_DIALOG_DATA) data: any,private utilService:UtilityService,private notifier:NotifierService, private spinner: NgxSpinnerService) { 
    // this.meetingInfo = data ;
    this.loggedInUserId=this.globals.userId;
  }

  @Input() meetingInfo: any;
  followUp = new UntypedFormGroup({
    meetingTitle: new UntypedFormControl(''),
    meetingStartTime: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
    meetingDate: new UntypedFormControl(''),
    meetingDateStr:new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    meetingId: new UntypedFormControl(''),
    includeAttendee: new UntypedFormControl(''),
    includeAgenda: new UntypedFormControl(''),
    //includeSelectedAgenda: new FormControl(''),
    //agendaTitle: new FormControl(''),
    attendeeIds: new UntypedFormControl(''),
    meetingLinkType: new UntypedFormControl(''),
    meetingTypeCode: new UntypedFormControl(''),
    agendaIds: new UntypedFormControl(''),
    isMeetingSaveWithSchedule: new UntypedFormControl(''),
    decryptKey: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    orgCode: new UntypedFormControl(''),
    visitorTimeZone: new UntypedFormControl(''),
    templateMeetingId: new UntypedFormControl('')
  });
  setData(){
    // this.followUp.controls['meetingStartTime'].setValue(this.meetingInfo.meetingData.meetingStartTime);
    
    this.followUp.controls['userId'].setValue(this.globals.userId);
    this.followUp.controls['orgCode'].setValue(this.globals.orgCode);
    this.followUp.controls['visitorTimeZone'].setValue(this.globals.vTimeZone);
    this.followUp.controls['meetingId'].setValue(this.meetingInfo.meeting.meetingId);
    this.followUp.controls['meetingDate'].setValue(moment(new Date()).zone(this.globals.vTimeZoneOffset));
    this.followUp.controls['meetingDateStr'].setValue(moment(new Date()).zone(this.globals.vTimeZoneOffset).format('MMM DD, yyyy'));
    this.followUp.controls['meetingTitle'].setValue(this.meetingInfo.meeting.meetingTitle);
    this.followUp.controls['meetingStartTime'].setValue(this.utilService.getDefaultMeetingTime());
    this.followUp.controls['meetingLinkType'].setValue(environment_const.followupTypeCode);
    this.followUp.controls['meetingTypeCode'].setValue(environment_const.followupTypeCode);
    this.followUp.controls['includeAgenda'].setValue("Y");
    this.followUp.controls['includeAttendee'].setValue("Y");
    this.followUp.controls['templateMeetingId'].setValue(this.meetingInfo.meeting.templateMeetingId);
  }

  ngOnInit(): void {
    
    this.setData();
    //alert("Reschedule"+this.meetingInfo.meeting); 
    this.selectedParticipant = 1; 
    this.selectedAgenda = 1;  
    this.attendeeService.fetchAttendee(this.meetingInfo.meeting.meetingId).subscribe((dataObj: any) => {
      
      this.attendeeList=dataObj;
      // if(this.attendeeList!=null && this.attendeeList.length<=1){
      //   this.disableUser=true;
      // }
    });
    this.meetingService.fetchAgendaListByMeetingId(this.meetingInfo.meeting.meetingId).subscribe((dataObj: any) => {
      
      this.agendaList=dataObj.body;
    });
    
  }
  onAttendeeRemoved(removedUserObj: string) {
    //const toppings = this.participantControl.value;
    //this.removeFirst(toppings, topping);
    //this.participantControl.setValue(toppings); // To trigger change detection
    // let index = toppings?.indexOf(removedUserObj);
    //     //
    //     if (index !== -1 && index != null) {
    //       //
    //       toppings?.splice(index, 1);
    //       this.participantControl.setValue(toppings);
    //     }
    this.removeSelection(this.participantControl,removedUserObj);
  }

  assignMeetingDate(event: MatDatepickerInputEvent<Date>) {
    
    //if (type == "change") {
        //this.meetingSelectedDateValues = this.datepipe.transform(this.followUp.value, "MMM dd, YYYY");
    //}
    this.followUp.controls['meetingDateStr'].setValue(moment(event.value).format('MMM DD, yyyy'));
  }

  attendeeTrigger(event:any){
    
    
    //this.selectedParticipant=[];
    this.followUp.controls['attendeeIds'].setValue(this.loadAttendeeIds());

  }

  loadAttendeeIds(){
    var attendeeIds = "";
    if(this.participantControl.value!=null){
      this.participantControl.value.forEach((element:any) => {
        attendeeIds+=element.fkSecUserAttendee+",";
      });
      if(attendeeIds!=null && attendeeIds.endsWith(",")){
        attendeeIds=attendeeIds.slice(0,attendeeIds.length-1);
      }
    }
    return attendeeIds;
  }


  loadAgendaIds(){
    var agendaIds = "";
    if(this.agendaControl.value!=null){
      this.agendaControl.value.forEach((element:any) => {
        agendaIds+=element.agendaId+",";
      });
      if(agendaIds!=null && agendaIds.endsWith(",")){
        agendaIds=agendaIds.slice(0,agendaIds.length-1);
      }
    }
    return agendaIds;
  }

  private removeSelection(toppingsCrl:any, toRemove: any): void {
    // const index = array.indexOf(toRemove);
    // if (index !== -1) {
    //   array.splice(index, 1);
    // }
    var toppings = toppingsCrl.value;
    let index = toppings?.indexOf(toRemove);
        //
        if (index !== -1 && index != null) {
          //
          toppings?.splice(index, 1);
          
        }
        toppingsCrl.setValue(toppings);
  }

  
  onAgendaRemoved(toRemove: any) {
    // const toppings = this.agendaControl.value as string[];
    // this.removeTwo(toppings, topping);
    // this.agendaControl.setValue(toppings); // To trigger change detection
    this.removeSelection(this.agendaControl,toRemove);
    
  }

  agendaTrigger(){
 
    //this.removeSelection(this.participantControl,removedUserObj);
    this.followUp.controls['agendaIds'].setValue(this.loadAgendaIds());

  }

  closeDialog() {
    this.matDialogRef.close(false)
  }
  isValidAgenda(agObj:any){
    if(agObj?.agendaFollowupFlag !=='Y' && agObj?.agendaTitle!=null && agObj?.agendaTitle !=='<br/>' && agObj?.agendaTitle !=='<br>' && agObj?.agendaTitle.trim() !==''){
      return true;
    }else{
      return false;
    }
  }
  saveAsFollowupMeeting(isMeetingSaveWithSchedule:any){
    this.spinner.show();
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.READ);
    if(!accessFlag){
      this.spinner.hide();
      return;
    }
    this.followUp.controls['isMeetingSaveWithSchedule'].setValue(isMeetingSaveWithSchedule);
    var attendeeIdVal = this.loadAttendeeIds();
    if(this.selectedParticipant==2 && attendeeIdVal==""){
      this.notifier.show({
        type: 'error',
        message: "Please select participant"
      });
      this.spinner.hide();
      return false;
    }
    if(attendeeIdVal!=null && attendeeIdVal!=""){
      attendeeIdVal=this.globals.userId+","+attendeeIdVal;
    }
    this.followUp.controls['attendeeIds'].setValue(attendeeIdVal);
    var agendaIdsVal = "";
    if(this.selectedAgenda==2){
      agendaIdsVal = this.loadAgendaIds();
    }
    if(this.selectedAgenda==2 && agendaIdsVal==""){
      this.notifier.show({
        type: 'error',
        message: "Please select agenda"
      });
      this.spinner.hide();
      return false;
    }
    this.followUp.controls['agendaIds'].setValue(agendaIdsVal);
    
    var reqObj:any=[];
    reqObj.push(this.followUp.value);
    this.meetingService.saveFollowupMeeting(reqObj).subscribe((dataObj: any) => {
      this.matDialogRef.close(true);
      this.spinner.hide();
    });
    return false;
  }
  isValidAttendee(attObj:any){
    if(attObj?.fkSecUserAttendee !=null && attObj?.fkSecUserAttendee!=this.globals.userId){
      return true;
    }else{
      
      return false;
    }
  }
}
